export default function Hero() {
  const handleNavClick = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section
      id="hero"
      className="relative min-h-[600px] md:min-h-[680px] w-full flex items-center overflow-hidden pt-[72px]"
    >
      <div className="absolute inset-0 bg-gradient-to-br from-background-50 via-background-100 to-background-200"></div>
      <div className="absolute top-0 right-0 w-[600px] h-[600px] bg-primary-500/5 rounded-full blur-3xl -translate-y-1/2 translate-x-1/4"></div>
      <div className="absolute bottom-0 left-0 w-[400px] h-[400px] bg-accent-500/3 rounded-full blur-3xl translate-y-1/2 -translate-x-1/4"></div>

      <div className="relative w-full max-w-7xl mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full lg:max-w-[560px]">
            <span className="inline-block px-3 py-1 text-xs font-medium bg-primary-500/15 text-primary-400 rounded-full mb-5 border border-primary-500/20">
              高清免费 · 不缓冲追剧
            </span>

            <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-50 font-heading leading-tight">
              蚂蚁影视 · 全网热播一站畅享
            </h1>

            <p className="mt-3 text-lg md:text-xl text-foreground-300 font-heading">
              高清画质，流畅不卡顿，随时随地免费看大片
            </p>

            <p className="mt-6 text-sm md:text-base text-foreground-400 leading-relaxed max-w-[520px]">
              蚂蚁影视聚合全网最新热播电影、电视剧、综艺、动漫资源，每日更新热门内容，支持高清免费在线观看。无论是院线大片、经典剧集还是独家专题，这里都是您的一站式追剧入口。当前热推暑期档新片专题，涵盖动作、悬疑、喜剧等多元类型，满足全家人的观影需求。
            </p>

            <div className="mt-6 flex flex-wrap gap-6">
              <div className="flex items-center gap-2">
                <div className="w-8 h-8 flex items-center justify-center rounded-full bg-primary-500/10">
                  <i className="ri-fire-fill text-primary-400 text-sm"></i>
                </div>
                <div>
                  <div className="text-sm font-semibold text-foreground-200">日更 200+</div>
                  <div className="text-xs text-foreground-500">热门资源</div>
                </div>
              </div>
              <div className="flex items-center gap-2">
                <div className="w-8 h-8 flex items-center justify-center rounded-full bg-accent-500/10">
                  <i className="ri-shield-check-fill text-accent-400 text-sm"></i>
                </div>
                <div>
                  <div className="text-sm font-semibold text-foreground-200">1080P 高清</div>
                  <div className="text-xs text-foreground-500">流畅不缓冲</div>
                </div>
              </div>
              <div className="flex items-center gap-2">
                <div className="w-8 h-8 flex items-center justify-center rounded-full bg-primary-500/10">
                  <i className="ri-smartphone-line text-primary-400 text-sm"></i>
                </div>
                <div>
                  <div className="text-sm font-semibold text-foreground-200">多端同步</div>
                  <div className="text-xs text-foreground-500">手机/平板/电脑</div>
                </div>
              </div>
            </div>

            <div className="mt-8 flex flex-col sm:flex-row gap-3">
              <a
                href="#app"
                onClick={(e) => handleNavClick(e, '#app')}
                className="inline-flex items-center justify-center gap-2 px-8 py-3 bg-primary-500 text-background-950 font-semibold text-sm rounded-lg hover:bg-primary-400 transition-colors duration-200 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-download-2-line text-base"></i>
                下载蚂蚁影视APP
              </a>
              <a
                href="#cards"
                onClick={(e) => handleNavClick(e, '#cards')}
                className="inline-flex items-center justify-center gap-2 px-8 py-3 bg-background-300/60 text-foreground-200 font-medium text-sm rounded-lg hover:bg-background-300 transition-colors duration-200 border border-background-400/30 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-film-line text-base"></i>
                浏览精选内容
              </a>
            </div>
          </div>

          <div className="flex-1 w-full lg:max-w-[480px]">
            <div className="relative">
              <div className="absolute -inset-4 bg-gradient-to-r from-primary-500/10 to-accent-500/10 rounded-2xl blur-xl"></div>
              <div className="relative rounded-2xl overflow-hidden border border-background-300/40 bg-background-100/50">
                <img
                  src="https://readdy.ai/api/search-image?query=A%20cinematic%20dark%20abstract%20composition%20with%20warm%20golden%20and%20amber%20light%20streaks%20radiating%20from%20center%2C%20film%20grain%20texture%20overlay%2C%20movie%20projector%20light%20beam%20effects%2C%20rich%20deep%20charcoal%20background%20with%20subtle%20lens%20flare%2C%20elegant%20theatrical%20atmosphere%2C%20no%20text%2C%20artistic%20cinematic%20photography%20style&width=960&height=1280&seq=hero-main-visual&orientation=portrait"
                  alt="蚂蚁影视 - 高清免费在线观影平台主视觉"
                  className="w-full h-auto object-cover"
                  width="480"
                  height="640"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-background-950/60 via-transparent to-transparent"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}